export default "__VITE_ASSET__Cpffl_xF__"